import { Injectable } from '@angular/core';
import { createSelector, select, Store } from '@ngrx/store';
import { map, Observable } from 'rxjs';

import { ChartItemEntity } from '../components/chart-list/chart-item.entity';
import { ChartListEntity } from '../components/chart-list/chart-list.entity';
import { ChartOriginalSliceState, ChartSliceKey } from './chart.state';
import { featureSelector, ChartRootState } from './feature.store';

const baseSelector = createSelector(
	featureSelector,
	(state) => state[ChartSliceKey]
);

const listSelector = createSelector(baseSelector, (state) => state.list);

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const chartById = (id: number) =>
	createSelector(listSelector, (list) => list.elements.get(`${id}`));

@Injectable()
export class ChartSelector {
	public constructor(private readonly store: Store<ChartRootState>) {}

	private get state(): Observable<ChartOriginalSliceState> {
		return this.store.pipe(select(baseSelector));
	}

	public getLoading$(): Observable<boolean> {
		return this.state.pipe(map((state) => state.get('loading')));
	}

	public getChartList$(): Observable<ChartListEntity> {
		return this.state.pipe(map((state) => state.get('list')));
	}

	public getSuccessDeleteChart$(): Observable<boolean> {
		return this.state.pipe(map((state) => state.get('deleteSuccess')));
	}

	public getSelectedCharts$(
		selected: Array<string>
	): Observable<Array<ChartItemEntity>> {
		return this.getChartList$().pipe(
			map((list) =>
				selected.reduce<Array<ChartItemEntity>>((acc, curr) => {
					const maybe = list.elements.get(`${curr}`);
					if (maybe) {
						acc.push(maybe);
						return acc;
					}
					return acc;
				}, [])
			)
		);
	}
}
